import { Component } from '@angular/core';

@Component({
  selector: 'mtm-circle-icon',
  templateUrl: './circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class CircleIconComponent {}
